import {
    FULLSTORY_API_TOKEN,
    FullStoryApi,
    MAIN_API_TOKEN,
    MainApi,
    PENDO_API_TOKEN,
    PendoApi,
    SETTINGS_STORE_TOKEN,
    SettingsStore,
    USER_STORE_TOKEN,
    UserStore,
} from '@local/shared';
import { Provider } from '@servicetitan/react-ioc';
import { FC, PropsWithChildren } from 'react';

export const AppProvider: FC<PropsWithChildren> = ({ children }) => (
    <Provider
        singletons={[
            {
                provide: SETTINGS_STORE_TOKEN,
                useClass: SettingsStore,
            },
            {
                provide: USER_STORE_TOKEN,
                useClass: UserStore,
            },
            {
                provide: PENDO_API_TOKEN,
                useClass: PendoApi,
            },
            {
                provide: FULLSTORY_API_TOKEN,
                useClass: FullStoryApi,
            },
            {
                provide: MAIN_API_TOKEN,
                useClass: MainApi,
            },
        ]}
    >
        {children}
    </Provider>
);
